import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAnalytics, type Analytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyCiLWICWmHoivXoNgCgZfyfZ07WIyRVmjE',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'infra-verge.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'infra-verge',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'infra-verge.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '803378606947',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:803378606947:web:37d79c13933d4575d7d956',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? 'G-SRL65KLEMT',
};

let app: FirebaseApp;
let analytics: Analytics | null = null;

export function initFirebase(): void {
  if (typeof window === 'undefined') return;
  app = initializeApp(firebaseConfig);
  analytics = getAnalytics(app);
}

export function getFirebaseAnalytics(): Analytics | null {
  return analytics ?? null;
}
